module.exports = __webpack_public_path__ + "static/media/gabr_front.65919f87.webp";